import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";

interface MetadataFieldsProps {
  formData: {
    metaTitle: string;
    metaDescription: string;
    metaKeywords: string;
    metaRobots: string;
    metaAuthor: string;
    metaCopyright: string;
    ogTitle: string;
    ogDescription: string;
    ogImage: string;
    twitterCard: string;
    favicon: string;
  };
  onChange: (updates: Partial<MetadataFieldsProps['formData']>) => void;
}

export default function ProductMetadataFields({ formData, onChange }: MetadataFieldsProps) {
  return (
    <>
      <div className="border-t pt-6 mt-6">
        <h3 className="text-lg font-semibold mb-4">SEO & Metadata</h3>
        
        <div className="space-y-4">
          <div className="space-y-2">
            <Label htmlFor="metaTitle">Page Title</Label>
            <Input
              id="metaTitle"
              value={formData.metaTitle}
              onChange={(e) => onChange({ metaTitle: e.target.value })}
              placeholder="Product Title for SEO"
            />
          </div>

          <div className="space-y-2">
            <Label htmlFor="metaDescription">Meta Description</Label>
            <Textarea
              id="metaDescription"
              value={formData.metaDescription}
              onChange={(e) => onChange({ metaDescription: e.target.value })}
              placeholder="Brief description for search engines"
              rows={3}
            />
          </div>

          <div className="space-y-2">
            <Label htmlFor="metaKeywords">Keywords</Label>
            <Input
              id="metaKeywords"
              value={formData.metaKeywords}
              onChange={(e) => onChange({ metaKeywords: e.target.value })}
              placeholder="keyword1, keyword2, keyword3"
            />
          </div>

          <div className="space-y-2">
            <Label htmlFor="metaRobots">Robots</Label>
            <Input
              id="metaRobots"
              value={formData.metaRobots}
              onChange={(e) => onChange({ metaRobots: e.target.value })}
              placeholder="index, follow"
            />
          </div>

          <div className="space-y-2">
            <Label htmlFor="metaAuthor">Author</Label>
            <Input
              id="metaAuthor"
              value={formData.metaAuthor}
              onChange={(e) => onChange({ metaAuthor: e.target.value })}
              placeholder="Author Name"
            />
          </div>

          <div className="space-y-2">
            <Label htmlFor="metaCopyright">Copyright</Label>
            <Input
              id="metaCopyright"
              value={formData.metaCopyright}
              onChange={(e) => onChange({ metaCopyright: e.target.value })}
              placeholder="Company Name 2025"
            />
          </div>
        </div>
      </div>

      <div className="border-t pt-6 mt-6">
        <h3 className="text-lg font-semibold mb-4">Open Graph (Social Media)</h3>
        
        <div className="space-y-4">
          <div className="space-y-2">
            <Label htmlFor="ogTitle">OG Title</Label>
            <Input
              id="ogTitle"
              value={formData.ogTitle}
              onChange={(e) => onChange({ ogTitle: e.target.value })}
              placeholder="Product Title for Social Media"
            />
          </div>

          <div className="space-y-2">
            <Label htmlFor="ogDescription">OG Description</Label>
            <Textarea
              id="ogDescription"
              value={formData.ogDescription}
              onChange={(e) => onChange({ ogDescription: e.target.value })}
              placeholder="Brief description for Open Graph"
              rows={2}
            />
          </div>

          <div className="space-y-2">
            <Label htmlFor="ogImage">OG Image URL</Label>
            <Input
              id="ogImage"
              value={formData.ogImage}
              onChange={(e) => onChange({ ogImage: e.target.value })}
              placeholder="https://benvorabioscience.com/product-image.jpg"
            />
          </div>
        </div>
      </div>

      <div className="border-t pt-6 mt-6">
        <h3 className="text-lg font-semibold mb-4">Twitter Card</h3>
        
        <div className="space-y-2">
          <Label htmlFor="twitterCard">Twitter Card Type</Label>
          <Input
            id="twitterCard"
            value={formData.twitterCard}
            onChange={(e) => onChange({ twitterCard: e.target.value })}
            placeholder="summary_large_image"
          />
        </div>
      </div>

      <div className="border-t pt-6 mt-6">
        <h3 className="text-lg font-semibold mb-4">Other</h3>
        
        <div className="space-y-2">
          <Label htmlFor="favicon">Favicon Path</Label>
          <Input
            id="favicon"
            value={formData.favicon}
            onChange={(e) => onChange({ favicon: e.target.value })}
            placeholder="/favicon.ico"
          />
        </div>
      </div>
    </>
  );
}
